import { Col, Row } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import { StyledGrid } from 'shared/style/grid'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import AnimationSlider from './AnimationSlider'
import {
  AnimationSliderContainerType,
  AnimationSliderType
} from './AnimationSlider.types'

const getParsedReturn = (
  parsed?: Pick<AnimationSliderType, 'slides' | 'starterPopup' | 'subtitles'>
) => ({
  slides: parsed?.slides || [],
  subtitles: parsed?.subtitles || [],
  starterPopup: parsed?.starterPopup || { des: '', complement: '' }
})

const AnimationSliderContainer = ({ props }: AnimationSliderContainerType) => {
  const styleProps = useStyleMaps(props.styleMap)

  const { objects } = props

  const { slides, subtitles, starterPopup } = useMemo(() => {
    const stringifiedDescription = objects?.[0]?.des || ''

    try {
      const parsed = JSON.parse(stringifiedDescription)

      return getParsedReturn(parsed)
    } catch (error) {
      console.error('Error parsing JSON', error)

      return getParsedReturn()
    }
  }, [objects])

  if (!slides || slides.length === 0) {
    return null
  }

  return (
    <StyledGrid style={styleProps}>
      <Row style={{ justifyContent: 'center' }}>
        <Col lg={12}>
          <AnimationSlider
            {...props}
            slides={slides}
            subtitles={subtitles}
            starterPopup={starterPopup}
          />
        </Col>
      </Row>
    </StyledGrid>
  )
}

export default AnimationSliderContainer
